
import Vue from "vue";
import { Auth } from "aws-amplify";
import TextField from "@/components/molecules/TextField.vue";
import ButtonDefault from "@/components/atoms/ButtonDefault.vue";

export default Vue.extend({
  // NOTE: metaタグの設定
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
  components: { TextField, ButtonDefault },
  data() {
    return {
      username: "",
      message: "",
      submitting: false,
    };
  },
  methods: {
    async submit() {
      const { username } = this;

      try {
        this.submitting = true;
        await Auth.forgotPassword(username);
        this.$router.push({
          name: "resetPasswordSubmit",
          params: { username },
        });
      } catch (error: any) {
        this.submitting = false;
        console.error(error);
        if (error.code === "UserNotFoundException") {
          this.message = this.$t('schoolAccountResetPasswordPage.validation.userNotFound') as string;
        } else if (error.code === "LimitExceededException") {
          this.message = this.$t('schoolAccountResetPasswordPage.validation.limitExceeded') as string;
        } else {
          this.message = this.$t('schoolAccountResetPasswordPage.validation.genericError') as string;
        }
      }
    },
  },
});
